import styled from "styled-components";

export const ServicesContainer = styled.div`
    min-height: 800px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #010606;
    padding: 50px 0;

    @media screen and (max-width: 768px) {
        min-height: 1100px;
    }

    @media screen and (max-width: 480px) {
        min-height: 1300px;
    }

`
export const DoctorsContainer = styled.div`
    min-height: 800px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 50px 0;

    @media screen and (max-width: 768px) {
        min-height: 1100px;
    }

    @media screen and (max-width: 480px) {
        min-height: 1300px;
    }

`

export const ServicesWrapper = styled.div`
    max-width: 1000px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    align-items: center;
    grid-gap: 16px;
    padding: 20px 50px;

    @media screen and (max-width: 1000px) {
        grid-template-columns: 1fr 1fr;
        padding: 20px 50px;
    }

    @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;
        //padding: 0 20px;
        padding: 20px 50px;
    }

`

export const ServicesCard = styled.div`
    background: white;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 10px;
    max-height: 400px;
    padding: 30px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.2);
    transition: all 0.2s ease-in-out;

    &:hover {
        transform: scale(1.02);
    }

`

export const ServicesIcon = styled.img`
    height: 160px;
    width: 160px;
    margin-bottom: 40px;
    
`
export const DoctorsIcon = styled.img`
    
    height: 240px;
    width: 240px;
    margin-bottom: 40px;
    
`
export const CoursesIcon = styled.img`

    
    
`
export const RoomIcon = styled.img`
    height: 140px;
    width: 180px;
    margin-top: 20px;
    margin-left: 20px;

    
`
export const ServicesH1 = styled.h1`
    font-size: 2.5rem;
    color: #fff;
    margin-bottom: 64px;

    @media screen and (max-width: 480px) {
        font-size: 2rem;
    }

`
export const DoctorsH1 = styled.h1`
    font-size: 2.5rem;
    color: #010606;
    margin-bottom: 64px;

    @media screen and (max-width: 480px) {
        font-size: 2rem;
    }

`

export const ServicesH2 = styled.h2`
    font-size: 1.2rem;
    margin-bottom: 10px;
    font-weight: 900;
    
`

export const ServicesP = styled.p`
    font-size: 1rem;
    text-align: center;

`
export const BannerContainer = styled.div`
  background-color: transparent;
  min-height: 800px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
@media screen and (max-width: 768px) {
    min-height: 1100px;
}

@media screen and (max-width: 480px) {
    min-height: 1300px;
}
`

export const BannerHeading = styled.h2`
  margin-top: 50px;
  margin-bottom: 20px;
  font-weight: 900;
  text-align: center;
  font-size: 2rem;

  @media screen and (max-width: 768px) {
    font-size: 1.2rem;
    margin-top: 20px;
}

`

export const CoursesWrapper = styled.div`
max-width: 1000px;
margin: 0 auto;
display: grid;
grid-template-columns: 1fr 1fr 1fr;
align-items: center;
grid-gap: 16px;
padding: 20px 50px;

@media screen and (max-width: 1000px) {
    grid-template-columns: 1fr 1fr;
    padding: 20px 50px;
}

@media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    //padding: 0 20px;
    padding: 20px 50px;
}
`

export const CourseCard = styled.div`
  background: white;
  border-radius: 10px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden; /* Prevent content from spilling out */
  
  &:hover {
    transform: scale(1.02);
  }

  a {
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
    max-width: 100%; 
    color: #007bff; 
    text-decoration: none;

    &:hover {
      text-decoration: underline; 
    }
  }

  img {
    max-width: 100%;
    height: auto;
    border-radius: 10px; /* Match card radius */
    object-fit: cover;
  }

 
`;



export const CourseImage = styled.img`
  width: 100%;            /* Make the image responsive */
  height: 200px;          /* Fixed height to keep the size consistent */
  object-fit: cover;      /* Ensure the image maintains its aspect ratio */
  border-radius: 0.375rem;/* Same as 'rounded-3' in Bootstrap */
`;
export const CourseTitle = styled.h3`
  font-size: 20px;
  margin-top: 10px;
`
export const CourseDates = styled.div`
font-size: 0.9rem;
margin: 16px;
color: #666;

& > p {
  margin: 0;
}

& > p > span {
    font-size: 0.9rem;
  font-weight: bold;
  color: #333;
}
`;

export const CourseDescription = styled.p`
  font-size: 16px;
  color: #666;
  margin-top: 10px;
`
